import { z } from 'zod';
import { messageStatusSchema } from './common.js';
/**
 * WhatsApp messages (debts.md section 9): one per new مدين or دائن movement,
 * Arabic, sent after commit. GET /messages/{id} refreshes the status;
 * MESSAGE_RETRY sends a failed message again with a new idempotency key.
 */
export const DEBTS_TEMPLATES = { DEBIT: 'debts_debit', CREDIT: 'debts_credit' };
/** Meta refuses empty variables, so an empty statement is sent as this dash. */
export const EMPTY_STATEMENT_VARIABLE = '—';
export const messageSchema = z.object({
    id: z.string(),
    movementId: z.string(),
    accountId: z.string(),
    template: z.string(),
    phone: z.string().nullable(),
    status: messageStatusSchema,
    attempt: z.number().int().positive(),
    error: z.string().nullable(),
    createdAt: z.string(),
    sentAt: z.string().nullable(),
    deliveredAt: z.string().nullable(),
    readAt: z.string().nullable(),
    failedAt: z.string().nullable(),
});
//# sourceMappingURL=messages.js.map